import React, { useState, useEffect } from "react";
import {
  savePaymentGatewayConfig, getPaymentGatewayConfigs, getPaymentGatewayConfigById,
  updatePaymentGatewayConfig, deletePaymentGatewayConfig,getLookupByGroup 
} from "../../services/adminApi";
import "./PaymentGatewayConfig.css";
import { FaEdit, FaTrash } from "react-icons/fa";
import Swal from "sweetalert2";

const PaymentGatewayConfig = () => {
  const [loading, setLoading] = useState(false);
  const [gatewayList, setGatewayList] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [lookups, setLookups] = useState({ providers: [], modes: [] });
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    provider: "Demo",
    active_mode: "demo",
    demo_api_key: "",
    demo_secret_key: "",
    live_api_key: "",
    live_secret_key: ""
  });

   const fetchLookups = async () => {
    try {
      // Dono API call karo lookup data lane ke liye
      const [res1, res2] = await Promise.all([
        getLookupByGroup ("paymentGateway"), // API function call
        getLookupByGroup ("paymentMode")
      ]);

      setLookups({
        providers: res1.data.data, // [{key: "dummy", value: "Dummy"}, ...]
        modes: res2.data.data
      });
    } catch (err) {
      console.log("Error fetching lookups", err);
    }
  };

  useEffect(() => {
    loadGatewayList();
    fetchLookups(); // Yeh function dynamic data layega
  }, []);

  const loadGatewayList = async () => {
    try {
      const res = await getPaymentGatewayConfigs();
      if (res.data.success) setGatewayList(res.data.data || []);
    } catch (err) { console.log(err); }
  };

  useEffect(() => { loadGatewayList(); }, []);

  const handleEdit = async (id) => {
    try {
      const res = await getPaymentGatewayConfigById(id);
      if (res.data.success) {
        const config = res.data.data;
        setFormData({
          provider: config.provider || "",
          active_mode: config.active_mode || "",
          demo_api_key: config.demo_api_key || "",
          demo_secret_key: config.demo_secret_key || "",
          live_api_key: config.live_api_key || "",
          live_secret_key: config.live_secret_key || ""
        });
        setEditId(id);
        setShowForm(true);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    } catch (err) { console.log(err); }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc0000",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Delete It!"
    });

    if (!result.isConfirmed) return;

    try {
      const response = await deletePaymentGatewayConfig(id);

      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Deleted",
          text: "Configuration Deleted Successfully"
        });

        loadGatewayList();
      }
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Delete Failed",
        text: error?.response?.data?.message || "Something went wrong"
      });
    }
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    // Jab value change ho, tab errors ko reset/clear kar dein
    setErrors({}); 
    
    if (name === "provider") {
      setFormData(prev => ({ 
        ...prev, 
        provider: value, 
        demo_api_key: "", demo_secret_key: "", 
        live_api_key: "", live_secret_key: "" 
      }));
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  
  const validateGatewayKeys = () => {
    let newErrors = {};
    if (formData.provider === "dummy") {
      setErrors({});
      return true;
    }
    const isDemo = formData.active_mode === "demo";
    const api = isDemo ? formData.demo_api_key : formData.live_api_key;
    const secret = isDemo ? formData.demo_secret_key : formData.live_secret_key;

    if (!api?.trim()) newErrors.apiKey = `${isDemo ? "Demo" : "Live"} API Key is required`;
    if (!secret?.trim()) newErrors.secretKey = `${isDemo ? "Demo" : "Live"} Secret Key is required`;
    
    if (formData.provider === "razorpay" && api?.trim() && !/^rzp_(test|live)_[a-zA-Z0-9]+$/.test(api)) {
      newErrors.apiKey = "Invalid Razorpay API Key";
    }
    if (formData.provider === "razorpay" && secret?.trim() && secret.length < 10) {
      newErrors.secretKey = "Invalid Razorpay Secret Key";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!validateGatewayKeys()) return;

  try {
    setLoading(true);

    const response = editId
      ? await updatePaymentGatewayConfig(editId, formData)
      : await savePaymentGatewayConfig(formData);

    if (response.data.success) {
      await Swal.fire({
        icon: "success",
        title: editId ? "Updated Successfully" : "Saved Successfully",
        text: editId
          ? "Payment Gateway Configuration Updated Successfully"
          : "Payment Gateway Configuration Saved Successfully",
        confirmButtonColor: "#198754"
      });

      loadGatewayList();

      setFormData({
        provider: "",
        active_mode: "",
        demo_api_key: "",
        demo_secret_key: "",
        live_api_key: "",
        live_secret_key: ""
      });

      setShowForm(false);
      setEditId(null);
    }
  } catch (error) {
    console.error(error);

    Swal.fire({
      icon: "error",
      title: "Operation Failed",
      text:
        error?.response?.data?.message ||
        "Failed To Save Configuration",
      confirmButtonColor: "#dc3545"
    });
  } finally {
    setLoading(false);   // YE MISSING HAI
  }

  };

  return (
    <div className="payment-gateway-admin-page">
      <div className="payment-gateway-card">
        <div className="payment-gateway-header">
          <h4 className="payment-gateway-title">Payment Gateway Configuration</h4>
          <button className="add-new-btn" onClick={() => { setEditId(null); setShowForm(true);   setFormData({
            provider: "dummy",
            active_mode: "",
            demo_api_key: "",
            demo_secret_key: "",
            live_api_key: "",
            live_secret_key: ""
          });
          setErrors({});
          setShowForm(true);}} >+ Add New</button>
        </div>

        {!showForm && (
          <div className="gateway-list-card">
            <div className="table-responsive">
              <table className="table gateway-table">
                <thead>
                  <tr><th>ID</th><th>Provider</th><th>Mode</th><th>API Key</th><th>Secret Key</th><th>Action</th></tr>
                </thead>
                <tbody>
                  {gatewayList.length > 0 ? gatewayList.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.provider}</td>
                      <td><span className={item.active_mode === "live" ? "gateway-live-badge" : "gateway-demo-badge"}>{item.active_mode.toUpperCase()}</span></td>
                      <td>{item.active_mode === "demo" ? item.demo_api_key : item.live_api_key}</td>
                      <td>{item.active_mode === "demo" ? item.demo_secret_key : item.live_secret_key}</td>
                      <td className="gateway-action-cell">
                        <button className="gateway-edit-btn" onClick={() => handleEdit(item.id)}><FaEdit /></button>
                        <button className="gateway-delete-btn" onClick={() => handleDelete(item.id)}><FaTrash /></button>
                      </td>
                    </tr>
                  )) : <tr><td colSpan="6">No Records Found</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {showForm && (
          <div className="payment-gateway-body">
            <form onSubmit={handleSubmit}>
              <div className="gateway-form-header">
                <h5 className="text-white mb-0">Payment Gateway Details</h5>
                <button type="button" className="gateway-close-btn" onClick={() => setShowForm(false)}>✕</button>
              </div>
              <div className="mb-3">
                <label className="payment-gateway-label">Payment Gateway Provider</label>
                <select 
                  className="form-select payment-gateway-select" 
                  name="provider" 
                  value={formData.provider} 
                  onChange={handleChange}
                >
                  {lookups.providers.map((item, index) => (
                    <option key={index} value={item.key}>{item.value}</option>
                  ))}
                </select>
              </div>
              {formData.provider !== "dummy" && (
                <>
                  <div className="mb-4">
                    <label className="form-label fw-bold">Payment Mode</label>

                    <select
                      className="form-select payment-gateway-select"
                      name="active_mode"
                      value={formData.active_mode}
                      onChange={handleChange}
                    >
                      {lookups.modes.map((item, index) => (
                        <option key={index} value={item.key}>
                          {item.value}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="gateway-credential-card">
                    <div
                      className={
                        formData.active_mode === "demo"
                          ? "gateway-demo-header"
                          : "gateway-live-header"
                      }
                    >
                      {formData.active_mode === "demo"
                        ? "Demo"
                        : "Live"} Credentials
                    </div>

                    <div className="gateway-credential-body">
                      <div className="mb-3">
                        <label className="form-label fw-semibold">
                          {formData.active_mode === "demo"
                            ? "Demo"
                            : "Live"} API Key
                        </label>

                        <input
                          type="text"
                          className="form-control payment-gateway-input"
                          name={
                            formData.active_mode === "demo"
                              ? "demo_api_key"
                              : "live_api_key"
                          }
                          value={
                            formData.active_mode === "demo"
                              ? formData.demo_api_key
                              : formData.live_api_key
                          }
                          onChange={handleChange}
                        />

                        {errors.apiKey && (
                          <div className="text-danger small">
                            {errors.apiKey}
                          </div>
                        )}
                      </div>

                      <div>
                        <label className="form-label fw-semibold">
                          {formData.active_mode === "demo"
                            ? "Demo"
                            : "Live"} Secret Key
                        </label>

                        <input
                          type="text"
                          className="form-control payment-gateway-input"
                          name={
                            formData.active_mode === "demo"
                              ? "demo_secret_key"
                              : "live_secret_key"
                          }
                          value={
                            formData.active_mode === "demo"
                              ? formData.demo_secret_key
                              : formData.live_secret_key
                          }
                          onChange={handleChange}
                        />

                        {errors.secretKey && (
                          <div className="text-danger small">
                            {errors.secretKey}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}
              <button type="submit" className="payment-gateway-save-btn" disabled={loading}>
                {loading ? (editId ? "Updating..." : "Saving...") : (editId ? "Update Configuration" : "Save Configuration")}
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentGatewayConfig;